import { HttpClient } from '@opallabs/api'
import { ReduxOverwriteQueue } from '../../../jsonApiDeserializer/reduxUpdateQueue'
import { enqueueDelayedEntityResponse } from '../../../jsonApiDeserializer/responseEntityQueues'
import { loadJsonApiEntities } from '../../loadJsonApiEntities'
import updateJsonApiEntity from '../../updateJsonApiEntity'

const updateContent = ({ id, params }) =>
  HttpClient().patch(`/content/v2/${id}`, params)

const cleanRelationships = (entity, contentId) => {
  let newEntity = { ...entity }
  const relationships =
    newEntity.params.relationships && newEntity.params.relationships.posts
      ? newEntity.params.relationships.posts
      : null

  if (relationships) {
    for (let i = 0; i < relationships.length; i += 1) {
      if (relationships[i].id === contentId) {
        relationships.splice(i, 1)
      }
    }
    newEntity = {
      ...newEntity,
      ...{
        params: {
          ...newEntity.params,
          ...{
            relationships: {
              ...newEntity.params.relationships,
              ...{
                posts: relationships,
              },
            },
          },
        },
      },
    }
  }
  return newEntity
}

const updateContentV2 =
  ({
    contentId,
    params,
    callback,
    debounceEntityUpdates = false,
    shouldEnqueueReduxUpdates = false,
    updateReduxEntity = false,
    updateRelatedEntities = false,
    skipActivity = false,
  }) =>
  (dispatch) => {
    if (updateReduxEntity) {
      dispatch(
        updateJsonApiEntity({
          type: 'content',
          id: contentId,
          attributes: params || {},
          relationships: params.relationships || {},
        })
      )
    }

    if (updateRelatedEntities) {
      const entityArray = updateRelatedEntities.length
        ? updateRelatedEntities
        : [{ ...updateRelatedEntities }]
      entityArray.forEach((entity) => {
        const updatedEntity = cleanRelationships(entity, contentId)
        dispatch(
          updateJsonApiEntity({
            type: updatedEntity.type,
            id: updatedEntity.id,
            attributes: updatedEntity.params || {},
            relationships: updatedEntity.params.relationships || {},
          })
        )
      })
    }

    return updateContent({
      id: contentId,
      params: {
        id: contentId,
        skip_activity: skipActivity,
        data: {
          attributes: params,
        },
      },
    })
      .then((response) => {
        const responseData = response.data
        if (debounceEntityUpdates) {
          enqueueDelayedEntityResponse({
            type: 'content',
            id: contentId,
            data: responseData,
          })
          if (callback) callback(responseData.data)
          return null
        }

        if (shouldEnqueueReduxUpdates) {
          if (callback) callback(responseData.data)
          ReduxOverwriteQueue.addItem(responseData)
          return responseData.data
        }

        if (callback) callback(responseData.data)
        return dispatch(loadJsonApiEntities(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default updateContentV2
